export const GLOBAL_DATA = "GLOBAL_DATA";
export const DELETE_DATA = "DELETE_DATA";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const CLICK_NOTIFICATION = "CLICK_NOTIFICATION";
export const TOUCH_ALL_NOTIFICATIONS = "TOUCH_ALL_NOTIFICATIONS";
